import { createElement } from 'react';
import { BookOpen } from 'lucide-react';
import {
  createSlotComponent,
  createWebRegistrationFromManifest,
} from '@reflex/plugin-api/create-web-registration';
import { registerDocsHintRenderer } from '@reflex/ui/components/layout/Typography';
import { docsWeb } from '../web-manifest.js';

// Wire the docs-hint renderer so `<PanelTitle docs="concepts/agents">` (in
// `@reflex/ui`) can render this plugin's `DocsHint` without `@reflex/ui`
// taking a hard dependency on `plugin-docs`. Side-effect on module load — the
// host imports this file as part of plugin web registration, which runs
// before any React tree mounts.
//
// `DocsHint` loads through `createSlotComponent` (renders nothing until the
// module resolves, never suspends) so importing this module (e.g. from the
// plugin-docs contract test running under Node) does NOT eagerly pull in
// `DocPageRenderer` → the live block registry → `@reflex/ui/client/context` →
// browser-only modules. Only the renderer's first React render — which only
// happens in the browser — starts the import.
const SlotDocsHint = createSlotComponent(() =>
  import('./DocsHint.js').then((m) => ({ default: m.DocsHint })),
);
registerDocsHintRenderer(({ slug }) => createElement(SlotDocsHint, { slug }));

export default createWebRegistrationFromManifest(
  docsWeb,
  {
    DocsPage: () => import('./DocsPage'),
    DocsIndexPage: () => import('./DocsIndexPage'),
  },
  {
    icons: { BookOpen },
  },
);
